import { Colors } from '@lean-body/components/styles';
const VOLUME_COLORS = ['green', 'pink', 'yellow', 'blue'];
const VOLUME_SOLID_COLORS = {
    green: Colors.ProgressGreen,
    pink: Colors.Accent,
    yellow: Colors.YellowVivid,
    blue: Colors.ProgressBlue,
};
export const DAILY_LESSON_DEFAULT_OPACITY = 0.4;
export const DAILY_LESSON_FUTURE_ICON_OPACITY = 0.3;
export const colorForVolumeNumber = (volumeNumber) => VOLUME_COLORS[(volumeNumber - 1) % VOLUME_COLORS.length];
export const dailyLessonVolumeSolidColor = (color) => VOLUME_SOLID_COLORS[color];
